<template>
  <v-container fluid class="pa-0">
    <v-row class="pb-0">
      <v-col class="primary--text font-weight-bold px-0 pt-6">
        {{ $t('titulo_evaluacion') | capitalize }}
      </v-col>
    </v-row>
    <v-row class="pb-0">
      <v-col class="pa-0" cols="12">{{ $t("descrip_evaluacion") }}</v-col>
    </v-row>
    <v-row class="pb-0">
      <v-col class="pa-0" cols="12">
        <v-select v-model="usoEvaluar" :items="material.usos" item-text="nombre" return-object
                  :label="$options.filters.capitalize($t('label_usos'))" clearable hide-details/>
      </v-col>
    </v-row>
    <v-row class="pb-0">
      <v-col cols="12" class="text-right">
        <v-btn color="primary" depressed :disabled="!usoEvaluar" @click="evaluar(material)">
          {{ $t('btn_evaluar') | capitalize }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "EvaluarMaterialPersonalizado",
  props: {
    material: {required: true, type: Object}
  },
  data: () => ({
    usoEvaluar: null,
  }),
  methods: {
    evaluar(material) {
      let params = {uso: this.usoEvaluar};
      if (material.ceramicos.length > 0) params.ceramicoPers = material;
      else {
        params.noCeramicoPers = material;
      }
      let query = {};
      const claveCompartir = this.$route.query["clave-compartir"] ? this.$route.query["clave-compartir"] : null;
      if (claveCompartir) query["clave-compartir"] = claveCompartir;

      this.$router.push({name: 'proyecto-nuevo', params: params, query: query});
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "label_usos": "Tipo de uso / Solucion constructiva",
    "titulo_evaluacion": "Evaluación del material",
    "descrip_evaluacion": "En caso de querer proceder a la evaluación del material, seleccione el tipo uso de destino:",
    "btn_evaluar": "Evaluar"
  }
}
</i18n>
<!--@formatter:oon-->
